import axios from "axios";

export const API = axios.create({
  baseURL: "https://blogapi-backend-ovvk.onrender.com",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response || {};

    if (status === 401 && window.location.pathname !== "/signin") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/signin";
    }

    if (status === 404) {
      setTimeout(() => window.history.back(), 1000);
    }

    return Promise.reject(error);
  }
);
